import $ from "jquery";
window.$ = window.jQuery = $;

import validate from "jquery-validation";
import "jquery-validation/dist/additional-methods";

import 'bootstrap';

import * as bootstrap from 'bootstrap';
window.bootstrap = bootstrap;

require("./bootstrap");
require("./web/main");
